export function toRequestDueDate(date: Date): string {
  const dayAfter = new Date(date);
  dayAfter.setDate(dayAfter.getDate() + 1);
  return dayAfter.toISOString();
}

export function toDisplayDueDate(dueDate: string | Date): Date {
  const date = dueDate instanceof Date ? dueDate : new Date(dueDate);
  const dayBefore = new Date(date);
  dayBefore.setDate(dayBefore.getDate() - 1);
  return dayBefore;
}
